import React, { useState, useEffect } from "react";
import { Col, Row } from "react-bootstrap";
import $ from "jquery";
import Axios from "axios";
import JSZip from "jszip";
import moment from "moment-timezone";

import { useSite } from "./../../util/sites";
import GYAxios from "../../util/GYAxios";

import LoaderGraph from "../general/LoaderGraph";
import EmptyPage from "../general/EmptyPage";

function AdminOverview(props) {
	window.JSZip = JSZip;
	const currentSite = useSite();
	const [tableData, setTableData] = useState(null);
	const [selectedSite, setSelectedSite] = useState(null);

	/**
	 * Format result from API call
	 * @param {Result of API call} res
	 * @param {Values of selected site} values
	 */
	const formatData = (res, values) => {
		let resArr = [];
		res.map((row) => {
			let resObj = {};

			resObj.date = moment(row.dateData).format("YYYY-MM-DD");
			resObj.irrad = parseFloat((row.irradiance_sum / 6000).toFixed(3));
			resObj.solarTotal = parseFloat(row.solar_total.toFixed(3));
			resObj.PR = row.brut_PR;
			resObj.solarON = parseFloat(row.solar_ON.toFixed(3));
			resObj.solarOFF = parseFloat(row.solar_OFF.toFixed(3));

			resObj.percentageON =
				row.solar_total != 0
					? parseFloat(((row.solar_ON / row.solar_total) * 100).toFixed(3))
					: 0;
			resObj.savingsON = row.solar_ON * (values.price_on * values.discount_on);
			resObj.savingsOFF =
				row.solar_OFF * (values.price_off * values.discount_off);
			resObj.savingsTotal = parseFloat(
				(resObj.savingsON + resObj.savingsOFF).toFixed(2),
			);
			resObj.savingsON = parseFloat(resObj.savingsON.toFixed(2));
			resObj.savingsOFF = parseFloat(resObj.savingsOFF.toFixed(2));
			resObj.PEAcost = parseFloat(
				(
					row.solar_ON * values.price_on +
					row.solar_OFF * values.price_off
				).toFixed(2),
			);

			resObj.totalConso = parseFloat(
				(row.solar_total + row.grid_total).toFixed(3),
			);
			resObj.avgTemp = parseFloat(row.avg_temp_ambient.toFixed(2));
			resObj.control = row.control == null || row.control < 95 ? 0 : 1;

			resArr.push(resObj);
		});
		return resArr;
	};

	/**
	 * Fetch data of selected site
	 * @param {Selected Site} selectedSite
	 */
	const fetchData = (selectedSite) => {
		const dateFormat = "YYYYMMDD";
		const fromDate = moment().subtract(40, "days").format(dateFormat);
		const toDate = moment().format(dateFormat);

		// Site info
		const siteID = selectedSite.value.site_id;
		const tableName = selectedSite.value.table_name;
		const noOfInverters = selectedSite.value.nb_of_inverter;

		// Request URIs
		const dailyDataURI = `/daily/site/${siteID}/period/${fromDate}/${toDate}/order/dateData/DESC`;
		const controlDataURI = `/daily/site/${tableName}/period/${fromDate}/${toDate}/control?inverters=${noOfInverters}`;

		// Daily data requests
		const energyDataDailyReq = GYAxios.get(dailyDataURI);
		const controlReq = GYAxios.get(controlDataURI);

		Axios.all([energyDataDailyReq, controlReq])
			.then(
				Axios.spread((...responses) => {
					const resEnergyDataDaily = responses[0];
					const resControl = responses[1];

					const energyDataDaily =
						resEnergyDataDaily.data.error == null
							? resEnergyDataDaily.data
							: [];
					const controlData =
						resControl.data.error == null ? resControl.data : [];

					if (controlData.length === energyDataDaily.length) {
						for (let i = 0; i < energyDataDaily.length; i++)
							energyDataDaily[i].control = controlData[i].control;

						const dataArr = formatData(energyDataDaily, selectedSite.value);
						setTableData(dataArr);
					} else {
						let en = energyDataDaily.map((obj) => ({
							...obj,
							dateData: moment(obj.dateData).format("YYYY-MM-DD"),
							unused: 0,
						}));

						let ctrl = controlData.map((obj) => ({
							...obj,
							dateData: moment(obj.dateData).format("YYYY-MM-DD"),
						}));

						ctrl.map((ctrlObj) => {
							for (let i = 0; i < en.length; i++) {
								const enObj = en[i];
								if (enObj.dateData === ctrlObj.dateData) {
									enObj.control = ctrlObj.control;
									break;
								}
							}
						});
						const dataArr = formatData(en, selectedSite.value);
						setTableData(dataArr);
					}
				}),
			)
			.catch((err) => console.log("Request Error:", err));
	};

	// Set table data
	useEffect(() => {
		const site = props.selectedSite;

		if (site != null && site.label != currentSite.defaultSelect.label)
			setSelectedSite(props.selectedSite);
		else setSelectedSite(null);
	}, [props.selectedSite]);

	useEffect(() => {
		if (selectedSite != null) {
			$("#adminOverview").DataTable().destroy();
			fetchData(selectedSite);
		}
	}, [selectedSite]);

	useEffect(() => {
		// Datatables is imported in pages/_app.js
		if (selectedSite != null) {
			//Table config
			const opts = {
				lengthMenu: [
					[15, 30, -1],
					[15, 30, "All"],
				],
				columnDefs: [{ className: "table-center", targets: "_all" }],
				dom: "lfrtiBp",
				buttons: [
					{
						extend: "excelHtml5",
						text: "Download datas",
						title: `Datas_${selectedSite.value.table_name}`,
					},
				],
				responsive: true,
				ordering: true,
				order: [0, "desc"],
			};

			$("#adminOverview").DataTable(opts);
		}

		return () => {
			$("#adminOverview").DataTable().destroy();
		};
	}, [tableData]);

	return (
		<>
			<>
				<div className="panel-heading ">
					<Row>
						<Col md="6">
							<h2 className="panel-title" id="date">
								Sites Overview
							</h2>
						</Col>
						<Col md="6" style={{ textAlign: "right" }}></Col>
					</Row>
				</div>
				{selectedSite != null ? (
					<div className="panel-body">
						{tableData != null ? (
							<div className="panel-body">
								<table
									id="adminOverview"
									className="table table-striped table-bordered"
									style={{ width: "100%" }}
								>
									<thead>
										<tr>
											<th>Date</th>
											<th>Irradiation</th>
											<th>Production</th>
											<th>PR</th>
											<th>Prod On-Peak</th>
											<th>Prod Off-Peak</th>
											<th>% On</th>
											<th>Savings On-Peak</th>
											<th>Savings Off-Peak</th>
											<th>Total Savings</th>
											<th>Total PEA Cost</th>
											<th>Unused</th>
											<th>Avg Temp</th>
											<th>Total Conso</th>
										</tr>
									</thead>
									<tbody>
										{tableData.map((row, key) => {
											return (
												<tr key={key}>
													<td>{row.date}</td>
													<td>{row.irrad}</td>
													<td>{row.solarTotal}</td>
													<td>{row.PR}</td>
													<td>{row.solarON}</td>
													<td>{row.solarOFF}</td>
													<td>{row.percentageON}</td>
													<td>{row.savingsON}</td>
													<td>{row.savingsOFF}</td>
													<td>{row.savingsTotal}</td>
													<td>{row.PEAcost}</td>
													<td>{row.control}</td>
													<td>{row.avgTemp}</td>
													<td>{row.totalConso}</td>
												</tr>
											);
										})}
									</tbody>
								</table>
							</div>
						) : (
							<LoaderGraph
								style={{ height: "50vh" }}
								selectedSite={selectedSite}
							/>
						)}
					</div>
				) : (
					<EmptyPage message={"No site selected"} />
				)}
			</>
		</>
	);
}

export default AdminOverview;
